import type { Palette } from '../../common';

export const paletteDark: Palette = {
  brandColor: '#255dff',
  semanticColors: {
    red: '#FF4D4F',
    green: '#29A294',
    yellow: '#FAAD14',
  },
  basicColors: [
    '#ffffff',
    '#151a27',
    '#213f94',
    '#133aad',
    '#213f94',
    '#255dff',
    '#4b91ff',
    '#4b91ff',
    '#191919',
    '#1e2436',
    '#0647b1',
    '#7899ff',
    '#7899ff',
    '#f0f0f0',
    '#dcdcdc',
  ],
  basicColorRelations: [],
};
